import { createStore } from 'vuex'
import auth from './modules/auth'
import orders from './modules/orders'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth, orders
  }
})
